import {
    useEffect,
    useState,
} from 'react'

export default function useSyncState<T>(data: T, sync: boolean = true) {
    const [
        value,
        setValue,
    ] = useState<T>(data)

    useEffect(() => {
        if (data && sync) {
            setValue(data)
        }
    }, [
        data,
        sync,
    ])

    return {
        value,
        setValue,
    }
}
